import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ApiService } from '../../../services/api.service';
import { ParkingMall } from '../../../models/parking-mall.model';

@Component({
  selector: 'app-parking-malls-list',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './parking-malls-list.component.html',
  styleUrl: './parking-malls-list.component.scss'
})
export class ParkingMallsListComponent implements OnInit {
  parkingMalls: ParkingMall[] = [];
  loading = true;
  displayedColumns: string[] = ['name', 'location', 'spaces', 'occupancy', 'status', 'actions'];

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.loadParkingMalls();
  }

  loadParkingMalls(): void {
    this.loading = true;
    this.apiService.getParkingMalls().subscribe({
      next: (malls) => {
        this.parkingMalls = malls;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading parking malls:', err);
        this.loading = false;
      }
    });
  }

  getOccupancy(mall: ParkingMall): number {
    if (!mall.totalSpaces) return 0;
    const occupied = mall.totalSpaces - mall.availableSpaces;
    return Math.round((occupied / mall.totalSpaces) * 100);
  }

  editMall(mall: ParkingMall): void {
    console.log('Edit mall:', mall);
  }

  deleteMall(mall: ParkingMall): void {
    if (confirm(`Видалити паркінг "${mall.name}"?`)) {
      if (mall._id) {
        this.apiService.deleteParkingMall(mall._id).subscribe({
          next: () => {
            this.loadParkingMalls();
          },
          error: (err) => console.error('Error deleting mall:', err)
        });
      }
    }
  }
}
